import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <p className="mb-2 text-sm font-semibold text-brand-600">404</p>
      <h1 className="mb-3 text-2xl font-bold">Page not found</h1>
      <p className="mb-6 max-w-sm text-sm text-slate-600">
        The page you’re looking for doesn’t exist or was moved.
      </p>
      <Link
        to="/"
        className="rounded-full bg-gradient-to-br from-brand-500 to-brand-700 px-5 py-2.5 text-sm font-semibold text-white shadow-brand-md transition-all hover:shadow-brand-lg active:scale-[0.98]"
      >
        Back to home
      </Link>
    </div>
  );
}
